import React, {useEffect, useRef, useState} from 'react';
import Fade from "@material-ui/core/Fade";
import {secondsBetween} from "../../../../Utils/TimeUtils";
import {TableCell} from "../../../TableWithDraggableRows/TableWithDraggableRows";
import DoneIcon from '@material-ui/icons/DoneRounded';
import "./style.scss";
import {IconButton} from "@material-ui/core";
import XIcon from "@material-ui/icons/CloseRounded";

export function getTillLate(stop, finishTime) {
    const minutesBetweenOrderStartToDelivery = (secondsBetween(finishTime, stop.order.orderTime) / 60).toFixed(2);

    let percentTillLate = Math.round((minutesBetweenOrderStartToDelivery / stop.order.sla) * 100);

    const minutesTillLate = stop.order.sla - minutesBetweenOrderStartToDelivery;

    if (percentTillLate > 100)
        percentTillLate = 100;

    return {minutesBetweenOrderStartToDelivery, minutesTillLate, percentTillLate}
}

export default function AddressCell({index, route, row, isDragging, provided, snapshot, isEdit, onRemoveStopClicked: onRemoveStopClickedParent}) {
    const [isIndexVisible, setIndexVisibility] = useState(false);
    const visibilityTimeoutRef = useRef(null);
    const [stateIndex, setStateIndex] = useState(null);
    const [latenessColor, setLatenessColor] = useState('white');

    function setIndexAnimated(newIndex) {
        setIndexVisibility(false);

        if (visibilityTimeoutRef.current)
            clearTimeout(visibilityTimeoutRef.current);

        visibilityTimeoutRef.current = setTimeout(() => {
            setStateIndex(newIndex);
            setIndexVisibility(true);
            visibilityTimeoutRef.current = undefined;
        }, 200);
    }

    function updateLateness() {
        let finishTime;

        if (row.real_time_finish_time)
            finishTime = new Date(row.real_time_finish_time);
        else
            finishTime = new Date(new Date(route.timestamp).getTime() + row.duration * 1000);

        const tillLate = getTillLate(row, finishTime);

        if (tillLate) {
            if (tillLate.percentTillLate <= 50)
                setLatenessColor('ForestGreen');
            else if (tillLate.minutesTillLate > 5)
                setLatenessColor("#CCCC00");
            else
                setLatenessColor('Crimson');
        }
    }

    useEffect(() => {
        updateLateness();
    }, [row, route]);

    useEffect(() => {
        if (index === stateIndex)
            return;

        if (stateIndex == null) {
            setStateIndex(index);
            setIndexVisibility(true);
        } else
            setIndexAnimated(index);
    }, [index]);

    function onRemoveStopClicked() {
        if (onRemoveStopClickedParent)
            onRemoveStopClickedParent();
    }

    return (
        <TableCell
            isDragOccurring={isDragging}
            isDragging={snapshot.isDragging}
            cellId="address"
            className="cell"
            key={`row-${row.order_id}-cell-address`}
        >
            <div className="cell-content-wrapper">
                <div className="cell-content cell-address">
                    {
                        row.order.status === "DELIVERED" ?
                            <div className="delivered-icon">
                                <DoneIcon/>
                            </div>
                            :
                            null
                    }
                    {
                        isEdit && !isDragging ?
                            <IconButton className="remove-stop-button" onClick={onRemoveStopClicked}>
                                <XIcon/>
                            </IconButton>
                            :
                            null
                    }
                    <div className="stop-index">
                        <div className="stop-index-text">
                            <Fade timeout={250} in={isIndexVisible}>
                                <div>
                                    {stateIndex + 1}
                                </div>
                            </Fade>
                        </div>
                        <div className="stop-index-background"
                             style={{
                                 "backgroundColor": latenessColor
                             }}
                        />
                    </div>
                    <div className="stop-address">
                        {row.order.address}
                    </div>
                </div>
            </div>
        </TableCell>
    );
}